import { render } from "./MortgageAndPension.vue?vue&type=template&id=25712eb8"
import script from "./MortgageAndPension.vue?vue&type=script&lang=js"
export * from "./MortgageAndPension.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__